import { useRef, useState } from 'react';
import Modal from './Modal';
import Button from './Button';
import Input from './Input';
import CheckCircleIcon from './CheckCircleIcon';
import useCopy from '../util/useCopy';
import { useAsyncEffect } from 'hooks';
import { getIsLeagueNameTaken } from '../resources/League/services';
import { updateLeagueNameMutation } from '../resources/League/mutations';
import sleep from '../util/sleep';
import { LEAGUE_NAME_MAX_LENGTH } from '../config/constants';

let EditLeagueNameModal = ({
  isOpen,
  onClose,
  leagueId,
  currentName,
  userId,
}: {
  isOpen: boolean;
  onClose: () => void;
  leagueId: string;
  currentName: string;
  userId: string;
}) => {
  let copy = useCopy();
  let [nameInputValue, setNameInputValue] = useState(currentName.slice(0, LEAGUE_NAME_MAX_LENGTH));
  let [isNameTaken, setIsNameTaken] = useState<undefined | boolean>();
  let [isSaving, setIsSaving] = useState(false);

  let isNameDifferent = currentName !== nameInputValue;

  useAsyncEffect(
    async (getIsCurrent) => {
      setIsNameTaken(undefined);
      await sleep(300);
      if (!getIsCurrent()) return;
      let taken = await getIsLeagueNameTaken(nameInputValue);
      if (!getIsCurrent()) return;
      setIsNameTaken(taken);
    },
    [nameInputValue, setIsNameTaken],
  );

  let canSave = isNameDifferent && isNameTaken === false && !isSaving;

  let inputRef = useRef<HTMLInputElement>(null);

  return (
    <Modal isOpen={isOpen} onClose={onClose} onEntered={() => inputRef.current?.focus()}>
      <Modal.MainText>
        <p>{copy.enterANameForYourLeague}.</p>
      </Modal.MainText>
      <Modal.BottomActions>
        <p>
          {isNameTaken && isNameDifferent ? (
            copy.shootThatOneSAlreadyTaken
          ) : (
            <>&ensp;</>
          )}
        </p>
        <Input ref={inputRef} stacked value={nameInputValue} onChange={(v: string) => setNameInputValue(v.slice(0, LEAGUE_NAME_MAX_LENGTH))} />
        <Button
          stacked
          disabled={!canSave}
          isLoading={isSaving}
          onClick={async () => {
            setIsSaving(true);
            await updateLeagueNameMutation({
              leagueId,
              name: nameInputValue,
              userId,
            });
            setIsSaving(false);
            onClose();
          }}
          Icon={CheckCircleIcon}
        >
          {copy.save}
        </Button>
      </Modal.BottomActions>
    </Modal>
  );
};

export default EditLeagueNameModal;